// @ts-expect-error — js library
import Faye from 'faye'

import { DeferredSystem } from '../global/utils/DeferredSystem'
import { type AudienceMemberDTO } from '../Audience/model/Audience'

import { getAudienceRealtimeInfo } from './audienceRealtimeInfo'

const initAudienceRealtimeConnection = async () => {
  const { realtimeUrl, realtimeAuthorization } = await getAudienceRealtimeInfo()

  const fayeClient = new Faye.Client(realtimeUrl)
  fayeClient.disable('websocket')
  fayeClient.setHeader('Authorization', realtimeAuthorization)

  // needs a wrapper because the Faye Client is thenable
  return { client: fayeClient }
}

const realtimeConnection = new DeferredSystem(initAudienceRealtimeConnection)

const subscribe = async (callback: (message: AudienceMemberDTO) => unknown) => {
  const { client } = await realtimeConnection.get()
  const { realtimeChannel } = await getAudienceRealtimeInfo()

  return client.subscribe(realtimeChannel, (data: string) => {
    return callback(JSON.parse(data))
  })
}

export { subscribe }
